import { ReactComponent as Logo } from '../../res/image/logo.svg'
import './index.css'

const HeaderLogo = () => {
  return (
    <div className='header-logo-container'>
      <section className={`hd-section`}>
        <Logo className='logo' />
      </section>
    </div>
  )
}

export default HeaderLogo
